import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  PARTNERS,
  PARTNERS_P1_1,
  PARTNERS_P1_2,
  PARTNERS_P2_1,
  PARTNERS_P2_2,
  PARTNERS_P3_1,
  PARTNERS_P3_2,
  PARTNERS_P4,
  PARTNERS_P5_1,
  PARTNERS_P5_2,
  SUPPORTED_BY,
  SUPPORTED_BY_P1,
} from "../../translations/AboutUs/SutpIts";

function Partners() {
  return (
    <div class="main-container">
      <div class="main-header">{t(PARTNERS)}</div>
      <div class="wrap">
        <div>
          <img
            src={getImgPath("/img/aboutus/partners/urban_devlopment.png")}
            alt="urban_devlopment"
            width="52"
            height="50"
          />
        </div>
        <div class="wrap1">
          <div class="wrap2">{t(PARTNERS_P1_1)}</div>
          <div class="wrap3">{t(PARTNERS_P1_2)}</div>
        </div>
      </div>

      <div class="wrap">
        <div>
          <img
            src={getImgPath("/img/aboutus/partners/global_environment.png")}
            alt="global_environment"
            width="52"
            height="50"
          />
        </div>
        <div class="wrap1">
          <div class="wrap2">{t(PARTNERS_P2_1)}</div>
          <div class="wrap3">{t(PARTNERS_P2_2)}</div>
        </div>
      </div>

      <div class="wrap">
        <div>
          <img
            src={getImgPath("/img/aboutus/partners/world_bank.png")}
            alt="world_bank"
            width="52"
            height="50"
          />
        </div>
        <div class="wrap1">
          <div class="wrap2">{t(PARTNERS_P3_1)}</div>
          <div class="wrap3">{t(PARTNERS_P3_2)}</div>
        </div>
      </div>

      <div class="wrap">
        <div>
          <img
            src={getImgPath("/img/aboutus/partners/united_nation.png")}
            alt="united_nation"
            width="52"
            height="50"
          />
        </div>
        <div class="wrap1">
          <div class="wrap4">{t(PARTNERS_P4)}</div>
        </div>
      </div>

      <div class="wrap">
        <div>
          <img
            src={getImgPath("/img/aboutus/partners/forests.png")}
            alt="forests"
            width="52"
            height="50"
          />
        </div>
        <div class="wrap1">
          <div class="wrap2">{t(PARTNERS_P5_1)}</div>
          <div class="wrap3">{t(PARTNERS_P5_2)}</div>
        </div>
      </div>

      <div class="main-container">
        <div class="main-header">{t(SUPPORTED_BY)}</div>
        <div class="wrap5">
          <div>
            <img
              src={getImgPath("/img/aboutus/partners/urban_transport.png")}
              alt="urban_transport"
              width="52"
              height="50"
            />
          </div>
          <div class="wrap1">
            <div class="wrap5">{t(SUPPORTED_BY_P1)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
